import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppHttpService } from 'src/app/core/net/http/app-http.service';
@Injectable({
  providedIn: 'root'
})
export class WebPageCityService extends AppHttpService {

  constructor(protected httpClient: HttpClient) {
    super(httpClient);
  }

  public getWebPageCity(params: { city_id: number, url_name: string }): Observable<any> {
    return this.get(`web-api/web-page-city/get/${params.city_id}/${params.url_name}`).pipe(
      map((response) => response)
    );
  }
}
